export default __webpack_public_path__ + "static/note-0b869f79d03034be240f66dfc4459b0c.svg";